<template>
  <div>
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">Additional Data</h5>
      <div class="pull-right">
        <b-button variant="outline-primary" @click="addRows()"><i class="fa fa-plus"></i>&nbsp; Add new data</b-button>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <td><strong>Key</strong></td>
          <td><strong>Data Type</strong></td>
          <td><strong>Value</strong></td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(dt, index) in metadata" :key="index">
          <!-- For Input Key -->
          <td>
            <input
              v-model="dt.key"
              type="text"
              class="form-control"
              placeholder="Key">
          </td>
          <!-- End Input Key -->

          <!-- For Select Data Type -->
          <td>
            <b-form-select
              v-model="dt.type"
              :options="dataTypeOpt">
            </b-form-select>
          </td>
          <!-- End For Select Data Type -->

          <!-- For Input Value -->
          <td v-if="dt.type === 'string'">
            <input
              v-model="dt.value"
              type="text"
              class="form-control"
              placeholder="Value">
          </td>
          <td v-else-if="dt.type === 'number'">
            <input
              v-model="dt.value"
              type="number"
              class="form-control"
              placeholder="Value">
          </td>
          <td v-else-if="dt.type === 'boolean'">
            <b-form-select
              v-model="dt.value"
              :options="booleanOpt">
            </b-form-select>
          </td>
          <td v-else-if="dt.type === 'json'">
            <b-form-textarea
              v-model="dt.value"
              class="form-control"
              placeholder="{'key': 'value'}">
            </b-form-textarea>
          </td>
          <!-- End Input Value -->

          <td>
            <b-button variant="outline-danger" @click="removeElement(index)">
              <i class="fa fa-remove"></i>&nbsp; Delete
            </b-button>
          </td>
        </tr>
        <tr v-for="(meta, index) in metaNew" :key="`new-${index}`">
          <!-- For Input Key -->
          <td>
            <input
              v-model="meta.key"
              type="text"
              class="form-control"
              placeholder="Key">
          </td>
          <!-- End Input Key -->

          <!-- For Select Data Type -->
          <td>
            <b-form-select
              v-model="meta.type"
              :options="dataTypeOpt">
            </b-form-select>
          </td>
          <!-- End For Select Data Type -->

          <!-- For Input Value -->
          <td v-if="meta.type === 'string'">
            <input
              v-model="meta.value"
              type="text"
              class="form-control"
              placeholder="Value">
          </td>
          <td v-else-if="meta.type === 'number'">
            <input
              v-model="meta.value"
              type="number"
              class="form-control"
              placeholder="Value">
          </td>
          <td v-else-if="meta.type === 'boolean'">
            <b-form-select
              v-model="meta.value"
              :options="booleanOpt">
            </b-form-select>
          </td>
          <td v-else-if="meta.type === 'json'">
            <b-form-textarea
              v-model="meta.value"
              class="form-control"
              placeholder="{'key': 'value'}">
            </b-form-textarea>
          </td>
          <!-- End Input Value -->

          <td>
            <b-button variant="outline-danger" @click="removeElement(index, true)">
              <i class="fa fa-remove"></i>&nbsp; Delete
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <hr>
    <b-button
      @click="onSubmit()"
      type="submit"
      variant="primary">Save changes</b-button>
    <b-button
      @click="onCancel()"
      type="reset"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </div>
</template>
<script>
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';

/* eslint-disable */
export default {
  name: 'additional_data',
  data() {
    return {
      metaNew: [],
      oldToRemove: [],
      form: {
        metadata: {},
      },
      dataTypeOpt: [
        { value: 'string', text: 'String', id: 'dt-opt-1' },
        { value: 'number', text: 'Number', id: 'dt-opt-2' },
        { value: 'boolean', text: 'Boolean', id: 'dt-opt-3' },
        { value: 'json', text: 'JSON String', id: 'dt-opt-4' },
      ],
      textJson: '',
      checkBool: true,
      booleanOpt: [
        { value: '', text: 'Please select one item', disabled: true },
        { value: true, text: 'True', id: 'opt-1' },
        { value: false, text: 'False', id: 'opt-2' },
      ],
    };
  },
  created() {
    const { companyId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'companies', name: 'Companies' },
    ];

    this.$store.commit('companies/SET_DETAIL_ID', companyId);
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    detailedInfo() {
      const detailInfo = this.$store.getters['companies/get_detail_data'];
      return detailInfo;
    },
    metadata() {
      const value = [];
      const { metadata } = this.detailedInfo;
      if (metadata != null) {
        for (const [keys, values] of Object.entries(metadata)) {
          if (this.oldToRemove.length) {
            const dataToSkip = find(this.oldToRemove, dt => dt == keys);
            if (!isUndefined(dataToSkip)) {
              continue;
            }
          }
          if (typeof values === 'string') {
            value.push({ key: keys, type: 'string', value: values });
          } else if (typeof values === 'number') {
            value.push({ key: keys, type: 'number', value: values });
          } else if (typeof values === 'boolean') {
            value.push({ key: keys, type: 'boolean', value: values });
          } else if (typeof values === 'object') {
            value.push({ key: keys, type: 'json', value: JSON.stringify(values) });
          }
        }
      } else {
        value.push({ key: '', type: 'string', value: '' });
      }
      return value;
    },
    displayName() {
      return this.detailedInfo.name;
    },
  },
  methods: {
    onSubmit() {
      this.metadata.forEach(dt => {
        if (this.oldToRemove.length) {
          const dataToSkip = find(this.oldToRemove, r => r == dt.key);
          if (!isUndefined(dataToSkip)) {
            return;
          }
        }
        if (dt.key === "") {
          return;
        }

        if (dt.type === 'string') {
          this.form.metadata[dt.key] = dt.value.toString();
        } else if (dt.type === 'number') {
          this.form.metadata[dt.key] = parseInt(dt.value);
        } else if (dt.type === 'boolean') {
          this.form.metadata[dt.key] = dt.value;
        } else {
          this.form.metadata[dt.key] = JSON.parse(dt.value);
        }
      });

      this.metaNew.forEach(dt => {
        if (dt.key === "") {
          return;
        }

        if (dt.type === 'string') {
          this.form.metadata[dt.key] = dt.value.toString();
        } else if (dt.type === 'number') {
          this.form.metadata[dt.key] = parseInt(dt.value);
        } else if (dt.type === 'boolean') {
          this.form.metadata[dt.key] = dt.value;
        } else {
          this.form.metadata[dt.key] = JSON.parse(dt.value);
        }
      });

      let { companyId } = this.$route.params;
      this.$store.dispatch('companies/UPDATE_DATA', this.form).then((company) => {
        this.metaNew = [];
        this.oldToRemove = [];
        this.form.metadata = {};
        this.$store.dispatch('companies/LOAD_DETAIL_DATA');
        this.$router.push(`/admin/companies/${companyId}/additional`);
      });
    },
    onCancel() {
      const { companyId } = this.$route.params;
      if (this.isEdit) {
        this.$router.push(`/admin/companies/${companyId}`);
      } else {
        this.$router.push('/admin/companies');
      }
    },
    addRows() {
      this.metaNew.push({ key: '', type: 'string', value: '' });
    },
    removeElement(index, newData = false) {
      if (!newData) {
        this.oldToRemove.push(this.metadata[index]['key']);
      } else {
        this.metaNew.splice(index, 1);
      }
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/AdditionalData.vue